"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnumList = getEnumList;
// Returns a list of Enum values. See 'USER_ROLES'.
function getEnumList(enumeration) {
    return Object.values(enumeration).filter(value => isNaN(Number(value)));
}
